import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import {
  useEventState,
  useEventActions
} from './EventContext';

import {
  addEventAttendee,
} from './restApi';

import styles from './EventAttendees.module.scss';

const NewEventAttendeesForm = () => {
  const state = useEventState();
  const { onResponse, onError, updateFirstName, updateLastName, updateEmail } = useEventActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    addEventAttendee({
      id: state?.event?.id,
      onResponse,
      onError,
      body: {
        event: state?.event,
        newEventAttendee: state?.newEventAttendee,
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <section className={styles.section}>
      <h2 className={styles.tableTitle}>
        Add Event Attendees
      </h2>

      <Form onSubmit={handleSubmit}>
        <Field label="First Name" id="firstName">
          <Input
            type="text"
            value={state?.newEventAttendee?.firstName || ''}
            onChange={(e) => {
              updateFirstName(e.target.value);
            }}
          />
        </Field>

        <Field label="Last Name" id="lastName">
          <Input
            type="text"
            value={state?.newEventAttendee?.lastName || ''}
            onChange={(e) => {
              updateLastName(e.target.value);
            }}
          />
        </Field>

        <Field label="Email" id="email">
          <Input
            type="email"
            value={state?.newEventAttendee?.email || ''}
            onChange={(e) => {
              updateEmail(e.target.value);
            }}
          />
        </Field>

        <ResponsiveContainer name="form-actions">
          <FormActions>
            <Button type="submit">
              Add New Attendee
            </Button>
          </FormActions>
        </ResponsiveContainer>
      </Form>
    </section>
  );
};

export default NewEventAttendeesForm;
